import Repository from './Repository';

const ledgers_resource = 'ledgers';



export default {
  ledgerModel(payload) {
    return Repository.post(`${ledgers_resource}`, payload)
  },

  // authenticatelogin(payload) {
  //   return Repository.post(`${user_login_resource}`, payload)
  // },
  // getuser(payload) {
  //   return Repository.post(`${single_user_resource}`, payload)
  // },
  // register(payload) {
  //   return Repository.post(`${user_register_resource}`, payload)
  // },
  // updateProfile(payload) {
  //   return Repository.post(`${update_user_resource}`, payload)
  // },
  // get_user_resources(payload) {
  //   return Repository.post(`${user_qurabani_resource}`, payload)
  // },
  // get_user_notifications(payload) {
  //   return Repository.post(`${user_notification_resource}`, payload)
  // },
  // forgetpassword(payload) {
  //   return Repository.post(`${user_forgetpassword_resource}`, payload)
  // },
  // sendmsgnotification(payload) {
  //   return Repository.post(`${send_message_notification}`, payload)
  // }
};
